(function(){
var reviewGrid=document.getElementById('pp-review-grid'), reviewSearch=document.getElementById('pp-review-search'), reviewMessage=document.getElementById('pp-review-message'), reviewPagination=document.getElementById('pp-review-pagination'), reviewPrevious=document.getElementById('pp-review-previous'), reviewNext=document.getElementById('pp-review-next'), reviewPageStatus=document.getElementById('pp-review-page-status');
var reviewWords={range:reviewGrid.dataset.range,readFull:reviewGrid.dataset.readFull,showLess:reviewGrid.dataset.showLess,automated:reviewGrid.dataset.automated,noResults:reviewGrid.dataset.noResults,loadError:reviewGrid.dataset.loadError};
var reviewAll=[], reviewMatches=[], reviewPage=0, reviewPageSize=6;
function revCard(r){
  var card=document.createElement('figure');
  card.className='review-card'; card.dataset.reviewId=r.id;
  var mark=document.createElement('span');
  mark.className='review-mark'; mark.setAttribute('aria-hidden','true'); mark.textContent='\u201c';
  var quote=document.createElement('blockquote'), body=document.createElement('p');
  body.textContent=r.p; quote.appendChild(body);
  if(r.p.length>180){
    var more=document.createElement('button');
    more.type='button'; more.className='review-read-more'; more.setAttribute('aria-expanded','false'); more.textContent=reviewWords.readFull;
    more.addEventListener('click',function(){
      var expanded=more.getAttribute('aria-expanded')!=='true';
      more.setAttribute('aria-expanded',String(expanded)); body.classList.toggle('is-expanded',expanded); more.textContent=expanded?reviewWords.showLess:reviewWords.readFull;
    });
    quote.appendChild(more);
  }
  var author=r.a?reviewWords.automated:String(r.w||'').trim();
  var caption=document.createElement('figcaption'), avatar=document.createElement('span'), name=document.createElement('span');
  avatar.className='review-avatar'; avatar.setAttribute('aria-hidden','true'); avatar.textContent=author.charAt(0).toUpperCase();
  name.textContent=author; caption.appendChild(avatar); caption.appendChild(name);
  card.appendChild(mark); card.appendChild(quote); card.appendChild(caption); return card;
}
function renderReviews(){
  reviewGrid.replaceChildren();
  var start=reviewPage*reviewPageSize, stop=Math.min(start+reviewPageSize,reviewMatches.length);
  reviewMatches.slice(start,stop).forEach(function(r){reviewGrid.appendChild(revCard(r));});
  reviewGrid.setAttribute('aria-busy','false');
  reviewMessage.hidden=reviewMatches.length>0;
  if(!reviewMatches.length)reviewMessage.textContent=reviewWords.noResults;
  reviewPagination.hidden=reviewMatches.length===0;
  reviewPrevious.disabled=reviewPage===0;
  reviewNext.disabled=stop>=reviewMatches.length;
  reviewPageStatus.textContent=reviewWords.range.replace('{start}',String(start+1)).replace('{end}',String(stop)).replace('{total}',reviewMatches.length.toLocaleString());
}
if(reviewGrid){
  reviewPrevious.addEventListener('click',function(){if(reviewPage>0){reviewPage--;renderReviews();}});
  reviewNext.addEventListener('click',function(){if((reviewPage+1)*reviewPageSize<reviewMatches.length){reviewPage++;renderReviews();}});
  reviewSearch.addEventListener('input',function(){
    var query=reviewSearch.value.trim().toLocaleLowerCase();
    reviewMatches=query?reviewAll.filter(function(r){return (r.p+' '+r.w).toLocaleLowerCase().includes(query);}):reviewAll;
    reviewPage=0;renderReviews();
  });
  function loadReviews(){
    fetch(reviewGrid.dataset.reviewsUrl).then(function(response){
      if(!response.ok)throw new Error('Feedback asset could not be loaded');
      return response.json();
    }).then(function(data){
      if(!data.reviews||!data.reviews.length)throw new Error('Feedback asset is empty');
      reviewAll=data.reviews;reviewMatches=reviewAll;reviewSearch.disabled=false;renderReviews();
    }).catch(function(){
      reviewGrid.setAttribute('aria-busy','false');reviewMessage.hidden=false;reviewMessage.textContent=reviewWords.loadError;
    });
  }
  if('IntersectionObserver' in window){
    var reviewObserver=new IntersectionObserver(function(entries){
      if(entries.some(function(entry){return entry.isIntersecting;})){reviewObserver.disconnect();loadReviews();}
    },{rootMargin:'250px'});
    reviewObserver.observe(document.querySelector('.feedback-section'));
  }else{loadReviews();}
}
})();

